import React from "react"
import Icon from "../icon"
import PropTypes from "prop-types"
import {Link, navigate} from "gatsby"

const CategoryTagItem = (props) =>{
  const {icon, title, color, path} = props
  if(!title){
    return;
  }
  return(
    <div className="m-t-24 m-l-15">
      <Link className="category-button" to={path} >
        <span className="category-item category">
          <span className="category-icon">
          <Icon
            icon={icon}
            color={color}
            size={15}
           />
           </span>
           <span className="category-title">{title}</span>
        </span>
      </Link>
    </div>
  )
}

CategoryTagItem.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  color: PropTypes.string
}

CategoryTagItem.defaultProps = {
  icon: '',
  title: '',
  color: ''
}

export default CategoryTagItem
